import { createRoute, Outlet } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { ChronosControlBar } from "@/features/chronos-sync/components/chronos-control-bar";
import { IdleGuard } from "@/features/chronos-sync/components/idle-guard";
import { WorkspaceProvider } from "@/features/chronos-sync/workspace-context";

function ChronosLayout() {
  return (
    <WorkspaceProvider>
      <div class="flex flex-1 flex-col min-h-0 h-full relative">
        <Outlet />
        <ChronosControlBar />
        {/* Idle detection lives at the layout level: it must watch the running
            timer on EVERY chronos tab, not just the dashboard. */}
        <IdleGuard />
      </div>
    </WorkspaceProvider>
  );
}

// Active workspace travels in `?ws=<id>` for all chronos routes: all
// data (projects, team, feed, tags, timesheet) is filtered by workspace, so
// without this a shared link would look different in another browser (would use the
// recipient's workspace). Validated in the parent route so it is available in
// any sub-route, and `WorkspaceProvider` syncs it with its state.
interface ChronosSearch {
  ws?: string;
}

export const chronosRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/chronos",
  validateSearch: (raw: Record<string, unknown>): ChronosSearch => ({
    ws: typeof raw.ws === "string" && raw.ws.trim() !== "" ? raw.ws : undefined,
  }),
  component: ChronosLayout,
});
